import React, { useEffect, useState } from "react";
import {
  Menu,
  DropdownMenu,
  Dropdown,
  DropdownItem,
  Popup,
} from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";
import { Permission } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./AdminMenu.scss";
import { PeerAppButton } from "../PeerAppButton/PeerAppButton";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import { useLanguage } from "../../../../contexts";
import iconDatos from "../../../../assets/svg/Vector 17.svg";

const permissionController = new Permission();

function TooltipWrapper({ collapsed, content, children }) {
  if (!collapsed) return children;
  return (
    <Popup
      content={content}
      position="right center"
      trigger={children}
      inverted
      size="small"
    />
  );
}

export function AdminMenu({ collapsed }) {
  const { pathname } = useLocation();
  const {
    user: { role, company, site },
    accessToken,
  } = useAuth();

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key;

  const [permissionActive, setPermissionsActive] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (name) =>
    setOpenDropdown((prev) => (prev === name ? null : name));

  const isCurrentPath = (path) => {
    if (path === pathname) return true;
    return false;
  };

  useEffect(() => {
    (async () => {
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getPermissionsByRole(
            accessToken,
            role._id,
            true
          );
          setPermissionsActive(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsActive([]);
      }
    })();
  }, [role]);

  return (
    <div className="admin-menu-wrap" style={{ width: collapsed ? "70px" : "200px" }}>
    <Menu fluid vertical className="admin-menu">
      {
        <>
          {/* ── Dashboard ── */}
          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionActive, role?._id, "dashboard", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("dashboard")}>
              <Menu.Item
                as={Link}
                to="/admin/dashboard"
                active={isCurrentPath("/admin/dashboard")}
                className="admin-nav-item"
              >
                {!collapsed && t("dashboard")}
              </Menu.Item>
            </TooltipWrapper>
          ) : null}

          {/* ── Gestión ── */}
          <TooltipWrapper collapsed={collapsed} content={t("management")}>
            <Dropdown
              item
              open={openDropdown === "management"}
              onOpen={() => toggleDropdown("management")}
              onClose={() => setOpenDropdown(null)}
              trigger={
                <span style={{ display: "flex", alignItems: "center" }}>
                  <img src={iconDatos} alt="management" className="menu-datos-icon" />
                  {!collapsed && t("management")}
                </span>
              }
            >
              <DropdownMenu>
                <DropdownItem as={Link} to="/admin/annual-plan" active={isCurrentPath("/admin/annual-plan")}>
                  {t("annual_plan")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/legal-requirements" active={isCurrentPath("/admin/legal-requirements")}>
                  {t("legal_requirements")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/accidents" active={isCurrentPath("/admin/accidents")}>
                  {t("accident_management")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/eval-riesgos" active={isCurrentPath("/admin/eval-riesgos")}>
                  {t("bell_mod_risk")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/work-permits" active={isCurrentPath("/admin/work-permits")}>
                  {t("work_permits")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/action-plans" active={isCurrentPath("/admin/action-plans")}>
                  {t("action_plan_management")}
                </DropdownItem>
                {/* Buscador de evidencias: solo master */}
                {isMaster(role) && (
                  <DropdownItem as={Link} to="/admin/evidence-search" active={isCurrentPath("/admin/evidence-search")}>
                    {t("evidence_search")}
                  </DropdownItem>
                )}
                {/* <DropdownItem as={Link} to="/admin/capacitaciones" active={isCurrentPath("/admin/capacitaciones")}>
                  {t("training_management")}
                </DropdownItem> */}
                {/* <DropdownItem as={Link} to="/admin/risk-evaluation" active={isCurrentPath("/admin/risk-evaluation")}>
                  {t("risk_evaluation")}
                </DropdownItem> */}
                {/* <DropdownItem as={Link} to="/admin/epp" active={isCurrentPath("/admin/epp")}>
                  EPP
                </DropdownItem> */}
                {/* <DropdownItem as={Link} to="/admin/training-matrix" active={isCurrentPath("/admin/training-matrix")}>
                  {t("training_matrix")}
                </DropdownItem> */}
                {/* <DropdownItem as={Link} to="/admin/checklist" active={isCurrentPath("/admin/checklist")}>
                  {t("checklist")}
                </DropdownItem> */}
                {/* <DropdownItem as={Link} to="/admin/training" active={isCurrentPath("/admin/training")}>
                  {t("training")}
                </DropdownItem> */}
              </DropdownMenu>
            </Dropdown>
          </TooltipWrapper> 

          {/* ── Check List ── */}
          {isMaster(role) || isAdmin(role) ||
          hasPermission(permissionActive, role?._id, "checklist", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("checklist")}>
              <Menu.Item
                as={Link}
                to="/admin/checklist"
                active={isCurrentPath("/admin/checklist")}
                className="admin-nav-item"
              >
                {!collapsed && t("checklist")}
              </Menu.Item>
            </TooltipWrapper>
          ) : null}

          

          {/* ── Due Diligence ── */}
          {isMaster(role) || isAdmin(role) ? (
            <TooltipWrapper collapsed={collapsed} content="Due Diligence">
              <Dropdown
                item
                open={openDropdown === "duediligence"}
                onOpen={() => toggleDropdown("duediligence")}
                onClose={() => setOpenDropdown(null)}
                trigger={
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconDatos} alt="due diligence" className="menu-datos-icon" />
                    {!collapsed && t("due_diligence")}
                  </span>
                }
              >
                <DropdownMenu>
                  <DropdownItem as={Link} to="/admin/dd-home" active={isCurrentPath("/admin/dd-home")}>
                    Metodología
                  </DropdownItem>
                  <DropdownItem as={Link} to="/admin/self-assessments" active={isCurrentPath("/admin/self-assessments")}>
                    Autoevaluación · DD
                  </DropdownItem>
                  <DropdownItem as={Link} to="/admin/ocde-guide" active={isCurrentPath("/admin/ocde-guide")}>
                    Guía OCDE
                  </DropdownItem>
                  <DropdownItem as={Link} to="/admin/audit-map" active={isCurrentPath("/admin/audit-map")}>
                    Mapa de Auditoría
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </TooltipWrapper>
          ) : null}

          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionActive, role?._id, "configure", "menu") ||
          hasPermission(permissionActive, role?._id, "users", "menu") ||
          hasPermission(permissionActive, role?._id, "sites", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("configure")}>
              <Dropdown
                item
                open={openDropdown === "configure"}
                onOpen={() => toggleDropdown("configure")}
                onClose={() => setOpenDropdown(null)}
                trigger={
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconDatos} alt="config" className="menu-datos-icon" />
                    {!collapsed && t("configure")}
                  </span>
                }
              >
                <DropdownMenu>
                  {isMaster(role) ||
                  hasPermission(permissionActive, role?._id, "users", "menu") ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/companies"
                      active={isCurrentPath("/admin/companies")}
                    >
                      {t("companies")}
                    </DropdownItem>
                  ) : null}
                  {isMaster(role) ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/integrations"
                      active={isCurrentPath("/admin/integrations")}
                    >
                      {t("integrations")}
                    </DropdownItem>
                  ) : null}
                  {isMaster(role) ||
                  (isAdmin(role) && company && !site) ||
                  hasPermission(permissionActive, role?._id, "sites", "menu") ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/sites"
                      active={isCurrentPath("/admin/sites")}
                    >
                      {t("sites")}
                    </DropdownItem>
                  ) : null}
                  {isMaster(role) ||
                  isAdmin(role) ||
                  hasPermission(permissionActive, role?._id, "users", "menu") ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/users"
                      active={isCurrentPath("/admin/users")}
                    >
                      {t("users")}
                    </DropdownItem>
                  ) : null}
                  {/* TEMP: Roles y Permisos deshabilitados momentáneamente */}
                  {/* {isMaster(role) ||
                  isAdmin(role) ||
                  hasPermission(permissionActive, role?._id, "roles", "menu") ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/config/roles"
                      active={isCurrentPath("/admin/config/roles")}
                    >
                      {t("roles")}
                    </DropdownItem>
                  ) : null}
                  {isMaster(role) ||
                  isAdmin(role) ||
                  hasPermission(permissionActive, role?._id, "permissions", "menu") ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/config/permissions"
                      active={isCurrentPath("/admin/config/permissions")}
                    >
                      {t("permissions")}
                    </DropdownItem>
                  ) : null} */}
                  {isMaster(role) || isAdmin(role) ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/divisions"
                      active={isCurrentPath("/admin/divisions")}
                    >
                      {t("divisions")}
                    </DropdownItem>
                  ) : null}
                  {isMaster(role) || isAdmin(role) ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/locations"
                      active={isCurrentPath("/admin/locations")}
                    >
                      {t("locations")}
                    </DropdownItem>
                  ) : null}
                  {isMaster(role) || isAdmin(role) ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/sectors"
                      active={isCurrentPath("/admin/sectors")}
                    >
                      {t("sectors")}
                    </DropdownItem>
                  ) : null}
                  {isMaster(role) || isAdmin(role) ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/occupations"
                      active={isCurrentPath("/admin/occupations")}
                    >
                      {t("occupations")}
                    </DropdownItem>
                  ) : null}
                  {isMaster(role) || isAdmin(role) ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/industries"
                      active={isCurrentPath("/admin/industries")}
                    >
                      {t("industries")}
                    </DropdownItem>
                  ) : null}
                  {isMaster(role) || isAdmin(role) ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/ciiu-activities"
                      active={isCurrentPath("/admin/ciiu-activities")}
                    >
                      {t("ciiu_activities")}
                    </DropdownItem>
                  ) : null}
                </DropdownMenu>
              </Dropdown>
            </TooltipWrapper>
          ) : null}

          {/* ── Parámetros ── */}
          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionActive, role?._id, "configure", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("human_resources")}>
            <Dropdown
              item
              trigger={
                <span style={{ display: "flex", alignItems: "center" }}>
                  <img src={iconDatos} alt="human_resources" className="menu-datos-icon" />
                  {!collapsed && t("human_resources")}
                </span>
              }
            >
              <DropdownMenu>
                <DropdownItem as={Link} to="/admin/employees" active={isCurrentPath("/admin/employees")}>
                  {t("employees")}
                </DropdownItem>
                {/* <DropdownItem as={Link} to="/admin/records" active={isCurrentPath("/admin/records")}>
                  {t("records")}
                </DropdownItem> */}
              </DropdownMenu>
            </Dropdown>
            </TooltipWrapper>
          ) : null}

          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionActive, role?._id, "configure", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("parameters")}>
            <Dropdown
              item
              trigger={
                <span style={{ display: "flex", alignItems: "center" }}>
                  <img src={iconDatos} alt="parameters" className="menu-datos-icon" />
                  {!collapsed && t("parameters")}
                </span>
              }
            >
              <DropdownMenu>
                <DropdownItem as={Link} to="/admin/countries" active={isCurrentPath("/admin/countries")}>
                  {t("countries")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/areas" active={isCurrentPath("/admin/areas")}>
                  {t("areas")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/activities" active={isCurrentPath("/admin/activities")}>
                  {t("activities")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/sources" active={isCurrentPath("/admin/sources")}>
                  {t("sources")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/frequencies" active={isCurrentPath("/admin/frequencies")}>
                  {t("frequencies")}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            </TooltipWrapper>
          ) : null}

          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionActive, role?._id, "configure", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("parameters_hse")}>
            <Dropdown
              item
              trigger={
                <span style={{ display: "flex", alignItems: "center" }}>
                  <img src={iconDatos} alt="parameters_hse" className="menu-datos-icon" />
                  {!collapsed && t("parameters_hse")}
                </span>
              }
            >
              <DropdownMenu>
                <DropdownItem as={Link} to="/admin/requirements" active={isCurrentPath("/admin/requirements")}>
                  {t("requirements")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/authorities" active={isCurrentPath("/admin/authorities")}>
                  {t("authorities")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/evidences" active={isCurrentPath("/admin/evidences")}>
                  {t("evidences")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/responsibles" active={isCurrentPath("/admin/responsibles")}>
                  {t("responsibles")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/accident-types" active={isCurrentPath("/admin/accident-types")}>
                  {t("accident_types")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/causes" active={isCurrentPath("/admin/causes")}>
                  {t("causes")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/training-topics" active={isCurrentPath("/admin/training-topics")}>
                  {t("training_topics")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/risk-types" active={isCurrentPath("/admin/risk-types")}>
                  {t("risk_types")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/potential-damages" active={isCurrentPath("/admin/potential-damages")}>
                  {t("potential_damages")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/contract-types" active={isCurrentPath("/admin/contract-types")}>
                  {t("contract_types")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/work-environments" active={isCurrentPath("/admin/work-environments")}>
                  {t("work_environments")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/accident-mechanisms" active={isCurrentPath("/admin/accident-mechanisms")}>
                  {t("accident_mechanisms")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/deviations" active={isCurrentPath("/admin/deviations")}>
                  {t("deviations")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/material-agents" active={isCurrentPath("/admin/material-agents")}>
                  {t("material_agents")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/work-processes" active={isCurrentPath("/admin/work-processes")}>
                  {t("work_processes")}
                </DropdownItem>
                <DropdownItem as={Link} to="/admin/injury-natures" active={isCurrentPath("/admin/injury-natures")}>
                  {t("injury_natures")}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            </TooltipWrapper>
          ) : null}

        </>
      }
    </Menu>
    <PeerAppButton collapsed={collapsed} />
    </div>
  );
}
